import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class MeetingStatus extends Enum {
  key!: string;
  value!: string;

  static LOCKED: MeetingStatus = {
    key: 'locked',
    get value() {
      return Lang.t('meeting.status-locked');
    }
  };

  static AVAILABLE: MeetingStatus = {
    key: 'available',
    get value() {
      return Lang.t('meeting.status-available');
    }
  };

  static BOOKED: MeetingStatus = {
    key: 'booked',
    get value() {
      return Lang.t('meeting.status-booked');
    }
  };

  static COMPLETED: MeetingStatus = {
    key: 'completed',
    get value() {
      return Lang.t('meeting.status-completed');
    }
  };

  static CANCELLED: MeetingStatus = {
    key: 'cancelled',
    get value() {
      return Lang.t('meeting.status-cancelled');
    }
  };

  static SKIPPED: MeetingStatus = {
    key: 'skipped',
    get value() {
      return Lang.t('meeting.status-skipped');
    }
  };
}
